/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports.cogs
 * @name ReportsCogsPosItemLinksCtrl
 */
angular.module('mercury.directives.inputpayrate')
.controller('InputPayrateModalCtrl', ["dialog", "$scope", "$filter", "$state", "dialogData", "PayRuleConstant", "shiftHelpers", function(dialog, $scope, $filter, $state, dialogData, PayRuleConstant, shiftHelpers) {

  $scope.staffMember = dialogData.staffMember;
  $scope.clock = dialogData.clock;
  $scope.activeStaffRole = dialogData.activeStaffRole;
  $scope.activePackages = dialogData.activePackages;

  $scope.packageNavigationManage = 'Time.Compliance.PayRulesManage';
  $scope.packageNavigationAdd = 'Time.Compliance.AddPackage';

  var outOfRangeError = 'Time periods are out of bounds for the clockin';
  var endBeforeStartError = 'End time is before start time';
  $scope.totalUnpaidBreakHours = shiftHelpers.calculateTotalUnpaidBreakDuration($scope.clock);

  // set up error messages for time range validation
  $scope.clock.rules.forEach(function(adj) {
    adj.timeRangeError = '';
  });

  var overrideIsDeleted = function(override) {
    return !!override.deletedAt;
  };

  /**
   * rule and override can be completely deleted if it was a new entry created in the browser
   * because there is no DB record to update
   */
  var deleteNewRule = function($index) {
    $scope.clock.rules.splice($index, 1);
  };

  /**
   * existing overrides need to have their records updated so we mark the deletedAt flag
   * instead of removing the whole entry
   */
  var deleteExistingOverride = function(override) {
    override.deletedAt = overrideIsDeleted(override) ? null : moment().format();
    return override;
  };

  /**
   * Add:
   * - if the override is new, delete it, otherwise update deleted field
   * Deactivate:
   * - if the override is new, set it back to null so the rule is no longer overridden
   * - otherwise update deleted field
   * TimeAdjust:
   * - if the override is being deactivated, change type to deactivate and keep the same details
   */
  var manageExistingOverride = function($index, rule, deactivate) {
    switch (rule.override.type) {
      case PayRuleConstant.OverrideType.Add:
        if (rule.override.newOverride) {
          deleteNewRule($index);
        } else {
          return deleteExistingOverride(rule.override);
        }
      break;
      case PayRuleConstant.OverrideType.Deactivate:
        if (rule.override.newOverride) {
          return null;
        } else {
          return deleteExistingOverride(rule.override);
        }
      break;
      case PayRuleConstant.OverrideType.TimeAdjustment:
        if (deactivate) {
          rule.override.type = PayRuleConstant.OverrideType.Deactivate;
          return rule.override;
        }
      break;
    }
  };

  /**
   * create a new override entry for an rule
   */
  var addNewOverride = function(ruleId, type) {
    var newOverride = {
      clockinId: $scope.clock.id,
      ruleId: ruleId,
      type: type,
      deletedAt: null,
      newOverride: true, // mark as a new record so we can freely delete it without DB updates
      appliedFrom: $scope.clock.clockinTime, // default to clockin times
      appliedTo: $scope.clock.clockoutTime
    };
    return newOverride;
  };

  /**
   * use an rule in calculations if:
   * - there is no override for the rule
   * - the override is Add type and HAS NOT been deleted
   * - an existing override is Deactivate type and HAS been deleted
   * - an existing override is TimeAdjustment type and HAS NOT been deleted
   */
  var useRule = function(rule) {
    return (
      (!rule.override) ||
      (rule.override.type === PayRuleConstant.OverrideType.Add && !overrideIsDeleted(rule.override)) ||
      (rule.override.type === PayRuleConstant.OverrideType.Deactivate && overrideIsDeleted(rule.override)) ||
      (rule.override.type === PayRuleConstant.OverrideType.TimeAdjustment && !overrideIsDeleted(rule.override))
      );
  };

  // find the package which contains the selected rule or return null if nothing is found
  var getActivePackageByRule = function(ruleId) {
    var filteredPackages = $scope.activePackages.filter(function(package) {
      var foundRules = package.rules.filter(function(fRule) {
        return fRule.id === ruleId;
      });
      return foundRules.length > 0;
    });
    return filteredPackages[0];
  };

  /**
   * Formats the rule type column of the table.
   * RuleType:
   *  0: add - Add a dollar amount to the hourly rate
   *  1: subtract - Subtract a dollar amount to the hourly rate
   *  2: equals - Override the hourly rate to the amount in the adustment
   *  3: multiple - multiply the hourly rate by the amount specified (eg, 1.5 = time and a half)
   *  4: percentageTotal - add a percentage of the total pay after all other adjustments
   */
  $scope.getRuleRate = function(clockin, rule) {
    var ruleRate;
    switch (rule.ruleType) {
      case 0:
      case PayRuleConstant.RuleType.Add:
        return ('+' + $filter('currency')(rule.ruleRate));
      case 1:
      case PayRuleConstant.RuleType.Subtract:
        return ('-' + $filter('currency')(rule.ruleRate));
      case 2:
      case PayRuleConstant.RuleType.Equals:
        return $filter('currency')(rule.ruleRate);
      case 3:
      case PayRuleConstant.RuleType.Multiple:
        var ad = clockin.hourlyRate * rule.ruleRate;
        ruleRate = ad - clockin.hourlyRate;
        return ('+' + $filter('currency')(ruleRate));
      case 4:
      case PayRuleConstant.RuleType.PercentageTotal:
        return '+' + rule.ruleRate + '%';
    }
  };

  // used for displaying the rule rate
  $scope.getReadableRate = function(ruleType, ruleRate) {
    switch (ruleType) {
      case 0:
      case PayRuleConstant.RuleType.Add:
        return ('+' + $filter('currency')(ruleRate));
      case 1:
      case PayRuleConstant.RuleType.Subtract:
        return ('-' + $filter('currency')(ruleRate));
      case 2:
      case PayRuleConstant.RuleType.Equals:
        return $filter('currency')(ruleRate);
      case 3:
      case PayRuleConstant.RuleType.Multiple:
        if (ruleRate < 0) {
          return Math.round(((ruleRate * 100) + 100) * 100) / 100 + '%';
        } else {
          return Math.round(((ruleRate * 100) - 100) * 100) / 100 + '%';
        }
      break;
      case 4:
      case PayRuleConstant.RuleType.PercentageTotal:
        return ruleRate + '%';
    }
  };

  // combine the rate with the name to make a readable rule name
  $scope.readableRuleName = function(rule) {
    var readableRate = $scope.getReadableRate(rule.ruleType, rule.ruleRate);
    var readableName = rule.ruleName + ' (' + readableRate + ')';
    return readableName;
  };

  /**
   * Formats the rule cost column of the table.
   */
  $scope.getRuleCost = function(clockin, rule) {
    var hours = $scope.getRuleHoursPaid(rule);
    switch (rule.ruleType) {
      case 0:
      case PayRuleConstant.RuleType.Add:
        return hours * (clockin.hourlyRate + rule.ruleRate);
      case 1:
      case PayRuleConstant.RuleType.Subtract:
        return hours * (clockin.hourlyRate - rule.ruleRate);
      case 2:
      case PayRuleConstant.RuleType.Equals:
        return hours * (rule.ruleRate);
      case 3:
      case PayRuleConstant.RuleType.Multiple:
        return hours * (clockin.hourlyRate * rule.ruleRate);
    }
  };

  /**
   * Default is not disabled
   * Rule should be shown as deactivated and be struck through if:
   * Deactivate:
   * - there is an override
   * - the override has not been deleted (deleting Deactivate override means rule is to be used)
   * Add:
   * - is not a new override but it has been set to deleted
   * - new overrides can just be deleted as there is no DB record to update
   */
  $scope.isDisabled = function(rule) {
    if (rule.override) {
      switch (rule.override.type) {
        case PayRuleConstant.OverrideType.Add:
          return (!rule.override.newOverride && overrideIsDeleted(rule.override));
        case PayRuleConstant.OverrideType.Deactivate:
          return !overrideIsDeleted(rule.override);
      }
    }
    return false;
  };

  /**
   * we don't want to allow times to be changed unless it's an active overridden rule
   * Do not allow:
   *  - any custom rule
   *  - any disabled rule
   *  - any rule without an override
   */
  $scope.shouldDisableTimeRule = function(rule) {
    return !(rule.override &&
      rule.override !== PayRuleConstant.RuleSource.Custom &&
      !$scope.isDisabled(rule)
      );
  };

  $scope.getRuleHoursWorked = function(rule) {
    // if the rule has already been processed by the backend then we don't need to do any calculations
    if (rule.processedTotalHours != null) {
      return rule.processedTotalHours;
    }

    if (rule.override) {
      return moment(rule.override.appliedTo).diff(moment(rule.override.appliedFrom), 'hours', true);
    } else {
      // currently the totalUnpaidBreakHours is only being deducted for rostered shifts i.e. rules with no.
      return rule.totalHours - $scope.totalUnpaidBreakHours;
    }
  };

  $scope.getRuleHoursPaid = function(rule) {
    if (rule.override) {
      return moment(rule.override.appliedTo).diff(moment(rule.override.appliedFrom), 'hours', true);
    } else {
      return rule.totalPaidHours;
    }
  };

  $scope.getOrdinaryHours = function(clock, paid) {
    var totalHours = moment(clock.clockoutTime).diff(moment(clock.clockinTime), 'hours', true);
    var adjustedHours = 0;
    angular.forEach(clock.rules, function(rule) {
      if (useRule(rule)) {
        var ruleHours = paid ? $scope.getRuleHoursPaid(rule) : $scope.getRuleHoursWorked(rule);
        adjustedHours += ruleHours;
      }
    });
    return totalHours - adjustedHours - $scope.totalUnpaidBreakHours;
  };

  $scope.getTotalCost = function(clock) {
    var cost = clock.hourlyRate * ($scope.getOrdinaryHours(clock, true));
    angular.forEach(clock.rules, function(rule) {
      if (useRule(rule)) {
        var c = $scope.getRuleCost(clock, rule);
        cost += c;
      }
    });
    return cost;
  };

  $scope.getTotalHours = function(clock) {
    var hours = $scope.getOrdinaryHours(clock, false);
    angular.forEach(clock.rules, function(rule) {
      if (useRule(rule)) {
        hours += $scope.getRuleHoursWorked(rule);
      }
    });
    return hours;
  };

  $scope.getAdjustedRate = function(clock) {
    return clock.adjustedHourlyRate;
  };

  /**
   * Newly added rules and time period rules will always have an override
   * Only valid scheduled rules may come through here without an override
   * Which means they will always be of Deactivate type
   */
  $scope.updateOverride = function($index, rule, deactivate) {
    if (rule.override) {
      rule.override = manageExistingOverride($index, rule, deactivate);
    } else {
      rule.override = addNewOverride(rule.ruleId, PayRuleConstant.OverrideType.Deactivate);
    }
  };

  /**
   * get a list of available rules from the active packages to be used in the auto complete search
   */
  $scope.ruleOptions = function() {
    var options = [];

    // flatten packages into list of rules
    angular.forEach($scope.activePackages, function(package) {
      angular.forEach(package.rules, function(adj) {
        // Dont include overridden/disabled rules in this dropdown menu
        if (!adj.override) {
          options.push({rule: adj, packageName: package.name});
        }
      });
    });
    return options;
  };

  /**
   * create a new rule
   * This will always be Add type as it comes from the add new rule flow
   */
  $scope.addRule = function(result) {
    var a = result.rule;
    var ruleObject = {
      ruleId: a.id,
      ruleName: a.name,
      ruleRate: a.rate,
      ruleType: a.type,
      clockinId: $scope.clock.id,
      source: a.packageType,
      startTime: $scope.clock.clockinTime,
      endTime: $scope.clock.clockoutTime,
      override: addNewOverride(a.id, PayRuleConstant.OverrideType.Add)
    };
    $scope.clock.rules.push(ruleObject);
  };

  /**
   * we only want to show the override icon if the rule has been manually added
   */
  $scope.getRuleIcon = function(rule) {
    if (rule.override && rule.override.type === PayRuleConstant.OverrideType.Add) {
      return PayRuleConstant.RuleTypeIcon.Override;
    } else {
      return PayRuleConstant.RuleTypeIcon[rule.source];
    }
  };

  /**
   * Looks through the list of rules in the scoped clockin to find any actions that relate to ignoring the current rule we are looking at.
   * So we can tell the user why that rule may not have all of it's time applied.
   * Rules have a list of Actions which have a type I.E IgnoreAdjustment/ IgnorePackage.
   * Then the action has a list of references which stores the string ID of the item to apply the action to
   * This is why we have to go several layers into filters to look in all references of all actions in all rules,
   * to find any that relate to the current rule we are looking at.
   * @param {*} rule the rule to check if any other rules are ignoring
   * @returns list of rules that are ignoring the rule we are checking in full or partially
   */
  $scope.rulesCurrentlyIgnoringRule = function(rule) {
    return $scope.clock.rules.filter(function(cr) {
      if (cr.actions != null) {
        return cr.actions.filter(function(a) {
          return a.type === 'RemoveAllAdjustments' || (a.references.filter(function(r) {
            return r.reference === rule.ruleId || r.reference === rule.packageId;
          }).length > 0);
        }).length > 0;
      }
    });
  };

  /**
   * Takes the list of rules ignoring the current rule and makes a tooltip out of their names
   * @param {*} rule the rule being ignored
   * @returns a string tooltip explaining which rules are ignoring the current rule
   */
  $scope.getIgnoredRuleTooltip = function(rule) {
    var ignoringRules = $scope.rulesCurrentlyIgnoringRule(rule);

    var tooltip = 'This adjustment is being partially or fully ignored by:';

    angular.forEach(ignoringRules, function(ir) {
      tooltip = tooltip + ' ' + ir.ruleName;
    });
    return tooltip;
  };

  /**
   * evaluates the current rule to see which tooltip to show
   * @param {*} rule the current rule
   * @returns the string of the tooltip to display
   */
  $scope.getRuleIconTooltip = function(rule) {
    if (rule.override && rule.override.type === PayRuleConstant.OverrideType.Add) {
      return PayRuleConstant.RuleTypeIconTooltip.Override;
    } else {
      return PayRuleConstant.RuleTypeIconTooltip[rule.source];
    }
  };

  // a rule that has not been overriden can not have their time periods changes
  // custom rules never can
  // NOTE: should ignore rules with overrides
  $scope.managedRuleTimePeriodTooltip = function(rule) {
    if (rule.override && rule.override.type === PayRuleConstant.OverrideType.Add) {
      return PayRuleConstant.TimePeriodTooltip.Override;
    } else {
      return PayRuleConstant.TimePeriodTooltip[rule.source];
    }
  };

  // NOTE: once we have developed the Manage page for each rule we can strip some of this out and just route by ruleId to that page instead
  // gets the package from the rule and routes to the manage page for that package
  $scope.navigateToPackage = function(rule) {
    var package = getActivePackageByRule(rule.ruleId);
    var packageId = package ? package.id : null;
    $state.go($scope.packageNavigationManage, {id: packageId})
    .then($scope.cancel());
  };

  // go to the compliance add package page
  $scope.navigateToAddPackage = function() {
    $state.go($scope.packageNavigationAdd)
    .then($scope.cancel());
  };

  // check that the rule or override time periods are within the clockin time range
  $scope.validTimeRange = function(rule) {

    // ignore disabled rules
    if ($scope.isDisabled(rule)) {
      rule.timeRangeError = '';
      return true;
    }

    // format the times to ignore seconds and milliseconds to account for different formatting of old rules
    // some rule times have seconds/milliseconds and some do not, so ignore them in the validity check
    var clockinTime = moment($scope.clock.clockinTime).format('YYYY-MM-D,HH:mm');
    var clockoutTime = moment($scope.clock.clockoutTime).format('YYYY-MM-D,HH:mm');

    var startTime = moment($scope.getPeriodStart(rule)).format('YYYY-MM-D,HH:mm');
    var endTime = moment($scope.getPeriodEnd(rule)).format('YYYY-MM-D,HH:mm');

    // both rule times are within the clockin times
    if ((startTime >= clockinTime && startTime < clockoutTime) &&
    (endTime > clockinTime && endTime <= clockoutTime)) {

      // within clockin times but end is before start
      if (endTime < startTime) {
        rule.timeRangeError = endBeforeStartError;
        return false;

        // valid
      } else {
        rule.timeRangeError = '';
        return true;
      }
      // rule times are outside clockin times
    } else {
      rule.timeRangeError = outOfRangeError;
      return false;
    }
  };

  // check for any time errors in the clockin rules
  $scope.invalidTimePeriods = function() {
    return $scope.clock.rules.filter(function(rule) {
      return rule.timeRangeError !== '';
    }).length > 0;
  };

  $scope.getPeriodStart = function(rule) {
    if (rule.override) {
      return rule.override.appliedFrom;
    }
    return rule.startTime;
  };

  $scope.getPeriodEnd = function(rule) {
    if (rule.override) {
      return rule.override.appliedTo;
    }
    return rule.endTime;
  };

  // create a new override entry and set the times to match the latest rule values
  $scope.createTimeAdjustOverride = function(rule) {
    var override = addNewOverride(rule.ruleId, PayRuleConstant.OverrideType.TimeAdjustment);
    override.appliedFrom = rule.startTime;
    override.appliedTo = rule.endTime;
    rule.override = override;
  };

  $scope.save = function(clock) {
    dialog.close({newClock: clock});
  };

  $scope.cancel = function() {
    dialog.close({});
  };
}]);
